<template>
  <div class="body">
    <v-container fluid fill-height class="main-container">
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="10">
            <v-row class=" px-3 text-center" style="justify-content: center">
  
              <v-col  v-if="infoVisible" cols="6">
                <transition name="slide-fade">
                  <Note :type="infoType" :permenant_dismiss="false">{{ this.infoMsg }}</Note>
                </transition>
              </v-col>
            </v-row>
          <v-row align="center" justify="center">
            <v-card class="pa-10" style="overflow: hidden;">
              <div class="box-container">
                    <LoginForm v-if="form == 'login'" @loginVerify="changeForm('loginVerify')" @gotoRegister="changeForm('register')" @gotoFpass="changeForm('forgotpassword')" />
                    <RegisterForm v-if="form == 'register'"  @gotoLogin="changeForm('login')"/>
                    <ForgetPasswordForm v-if="form == 'forgotpassword'" @gotoLogin="changeForm('login')" @gotoRegister="changeForm('register')"/>
                    <ResetPasswordForm v-if="form== 'resetPassword'" @gotoLogin="changeForm('login')"/>
                    <LoginVerificationForm v-if="form == 'loginVerify'"/>
              </div>
            </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import RegisterForm from '../../forms/RegisterForm'
import LoginForm from '../../forms/LoginForm'
import ForgetPasswordForm from '../../forms/ForgetPasswordForm'
import LoginVerificationForm from '../../forms/LoginVerificationForm'
import ResetPasswordForm from '../../forms/ResetPasswordForm'
import Note from './../../Utils/Note'
export default {
  components: {  Note, RegisterForm, LoginForm, ForgetPasswordForm, LoginVerificationForm, ResetPasswordForm },
  props: ['ActivePage'], //Should be passed from router for direct access.
  data() {
    return {
      infoType: 'info',
      infoMsg: '',
      infoVisible: false,
      form: this.ActivePage,
      leftShown: false,
    }
  },
  computed: {
    NoteOffset () {
      if(this.leftShown) return 0
      return 7
    }
  },
  formURlResolver: {
    login: 'Login',
    register: 'Register',
    forgotpassword: 'ForgotPassword',
    loginVerify: 'LoginVerification',
    ResetPassword : 'NewPassword'
  },
  methods: {
    addHashToLocation(routeName) {
      history.pushState(
        {},
        null,
        this.$router.resolve({ name: routeName }).href + window.location.search
      )
    },
    changeForm (form){
      this.infoVisible = false
      this.form= form
      this.leftShown = !this.leftShown
      this.addHashToLocation(this.$options.formURlResolver[form])
    },
  },
  mounted () {
    this.$store.commit('setPasswordUpdate', false)
    this.$root.$on('show-auth-info', (type, msg) => {
      this.infoVisible = true
      this.infoType = type
      this.infoMsg = msg
    })
  },
  created() {
  },
  
}
</script>

<style scoped>
div.body {
  width: 100%;
  height: 100%;
}
.main-container  {
  background: linear-gradient(90deg, rgba(219,69,135,1) 0%, rgba(219,69,135,1) 25%, rgba(120,38,74,1) 100%);
}
div .col{
  padding-left: 0;
  padding-right: 0;
}
.box-container{
  position:relative;
  height: auto;
}
.carsouel-slider{
  transition: all ease-in-out 0.5s;
  background-color: black;
  justify-content: center;
  align-items: center;
}
.slider-left{
  position: absolute; top: 0; left: 0;
}
.slider-right{
  position: absolute; top: 0; left: 100%;
  transform: translateX(-100%);
}
.slider-container{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
}
.slider-img{
  width: 225px;
  height: auto;
  margin: auto;
  display: block;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
{
  transform: translateX(10px);
  opacity: 0;
}
.react-code-input input[data-v-e1087700]{
  border-radius: 0 !important;
}
.v-form {
  margin:0 auto;
}
@media(max-width: 1250px){
.container > .container{
    max-width:100%;
    width:100%;
  }
}
</style>